import { render, staticRenderFns } from "./BloquearButacas.vue?vue&type=template&id=b232bd92"
import script from "./BloquearButacas.vue?vue&type=script&setup=true&lang=js"
export * from "./BloquearButacas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports